import { Role } from "../../helpers/role";

export const DealerRoutes = [
  {
    name: "DealerRoutes",
    path: `/${Role.Dealer}`,
    redirect: "/",
    component: () => import("@/layouts/Layout"),
    children: [
      {
        name: "DealerDashboard",
        path: "/",
        component: () => import("@/views/dealer/DealerHome"),
        meta: {
          authorize: [Role.Dealer],
        },
      },
      {
        name: "DealerActivatedList",
        path: "activated-list",
        component: () => import("@/views/acquisition/ActivatedList"),
        meta: {
          authorize: [Role.Dealer],
        },
      },

      {
        name: "DealerSignUp",
        path: "pay-later",
        component: () => import("@/views/dealer/SignUp"),
        meta: {
          authorize: [Role.Dealer],
        },
      },
      {
        name: "DealerForInstallation",
        path: "for-installation",
        component: () => import("@/views/dealer/ForInstallation"),
        // component: () => import("@/views/acquisition/components/signups_components/ForInstallation"),
        
        meta: {
          authorize: [Role.Dealer],
        },
      },
      {
        name: "DealerInstalledActivated",
        path: "installed-activated",
        component: () => import("@/views/dealer/InstalledActivated"),
        meta: {
          authorize: [Role.Dealer],
        },
      },

      {
        name: "DealerReportSignUp",
        path: "report-sign-up",
        component: () => import("@/views/dealer/ReportSignUp"),
        meta: {
          authorize: [Role.Dealer],
        },
      },

      {
        name: "DealerReportInstallation",
        path: "report-installation",
        component: () => import("@/views/dealer/ReportInstallation"),
        meta: {
          authorize: [Role.Dealer],
        },
      },

      {
        name: "DealerReportTopUp",
        path: "monthly-sales",
        component: () => import("@/views/dealer/ReportTopUp"),
        meta: {
          authorize: [Role.Dealer],
        },
      },

      {
        name: "DealerIbasUserList",
        path: "ibas-user-list",
        component: () => import("@/views/dealer/IbasUserList"),
        meta: {
          authorize: [Role.Dealer],
        },
      },

      {
        name: "DealerForConfirmation",
        path: "for-confirmation",
        component: () => import("@/views/dealer/ForConfirmation"),
        meta: {
          authorize: [Role.Dealer],
        },
      },

      {
        name: "DealerRetailerList",
        path: "retailers",
        component: () => import("@/views/dealer/RetailerList"),
        meta: {
          authorize: [Role.Dealer],
        },
      },

      {
        name: "DealerSubribriberList",
        path: "subscribers",
        component: () => import("@/views/acquisition/Subscribers"),
        meta: {
          authorize: [Role.Dealer],
        },
      },

      {
        name: "DealerSalesReport",
        path: "sales-report",
        component: () => import("@/views/dealer/RetailerSalesReport"),
        meta: {
          authorize: [Role.Dealer],
        },
      },

      {
        name: "RetailerTransactions",
        path: "retailer-transactions",
        component: () => import("@/views/dealer/RetailerTransactions"),
        meta: {
          authorize: [Role.Dealer],
        },
      },

      
    ],
  },
];
